export default "<div class=\"loader2\">Loading...</div>";